const CodigosDescuentos = [
  { codigo: "DESCUENTO_NO_CONDICIONADO", nombre: "DESCUENTO_NO_CONDICIONADO" },
  { codigo: "DESCUENTO_CONDICIONADO", nombre: "DESCUENTO_CONDICIONADO" },
];

export default CodigosDescuentos;
